import {
  Sparkles,
  Crosshair,
  Smile,
  Sun,
  CircleDot,
  Baby,
  AlignCenter,
  Scissors,
  Crown,
  Layers,
  Droplets,
} from "lucide-react";

export const CLINIC = {
  name: "Narayan Dental Care",
  tagline: "Multi Speciality Dental Clinic",
  doctor: "Dr. Swagat Panda",
  doctorHonorific: "Professor Dr. Swagat Panda · MDS",
  credentials: ["B.D.S (Lucknow)", "M.D.S (Kolkata)", "F.A.G.E"],
  address:
    "Plot No-9, adjacent to Banalata Apartment, Saheed Nagar, Bhubaneswar, Odisha 751007",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Narayan+Dental+Care,+Saheed+Nagar,+Bhubaneswar,+Odisha+751007",
  email: "drswagatndc@gmail.com",
  logo: "/assets/logo.png",
  doctorPhoto: "/assets/doctor.jpg",
};

export const SERVICES = [
  {
    name: "Cosmetic Dentistry",
    tag: "Aesthetic Artistry",
    desc: "Porcelain veneers, cosmetic bonding, and gum contouring for symmetrical, harmonious teeth.",
    icon: Sparkles,
  },
  {
    name: "Root Canal Treatment",
    tag: "Painless Endodontics",
    desc: "Single-sitting rotary endodontics saving decayed teeth with absolute comfort.",
    icon: Crosshair,
  },
  {
    name: "Smile Designing",
    tag: "Digital Facial Analysis",
    desc: "Tailor-made smile proportions curated using facial symmetry analysis and custom preview.",
    icon: Smile,
  },
  {
    name: "Teeth Whitening",
    tag: "Laser Light Precision",
    desc: "Professional in-office whitening lifting shades safely without enamel sensitivity.",
    icon: Sun,
  },
  {
    name: "Dental Implant",
    tag: "Permanent Restoration",
    desc: "Titanium root replacements providing lifelong stability, bite strength, and bone preservation.",
    icon: CircleDot,
  },
  {
    name: "Pediatric Dentistry",
    tag: "Child-Friendly Care",
    desc: "Gentle, stress-free dental visits, sealants, and early interception for kids.",
    icon: Baby,
  },
  {
    name: "Orthodontic Braces",
    tag: "Alignment Mastery",
    desc: "Clear aligners, ceramic braces, and modern brackets to correct crooked teeth and malocclusion.",
    icon: AlignCenter,
  },
  {
    name: "Surgical Extraction",
    tag: "Atraumatic Surgery",
    desc: "Minimally invasive impaction removals and wisdom tooth surgery with rapid recovery protocols.",
    icon: Scissors,
  },
  {
    name: "Dental Bridge and Crowns",
    tag: "Zirconia & E-Max",
    desc: "High-translucency monolithic crowns and bridges engineered to mimic natural tooth enamel.",
    icon: Crown,
  },
  {
    name: "Fixed & Removable Denture",
    tag: "Full Arch Prosthetics",
    desc: "Flexible partials and precision-fitted complete dentures restoring full masticatory joy.",
    icon: Layers,
  },
  {
    name: "Teeth Scaling & Polishing",
    tag: "Ultrasonic Hygiene",
    desc: "Gentle plaque and calculus removal with air-polishing to reverse gingivitis and restore fresh breath.",
    icon: Droplets,
  },
];

export const WEEKDAY_SLOTS = [
  "11:00 AM - 12:00 PM",
  "12:00 PM - 01:00 PM",
  "01:00 PM - 02:00 PM",
  "02:00 PM - 03:00 PM",
  "03:00 PM - 04:00 PM",
  "04:00 PM - 05:00 PM",
  "05:00 PM - 06:00 PM",
  "06:00 PM - 07:00 PM",
  "07:00 PM - 08:00 PM",
];

export const SUNDAY_SLOT = "Sunday Special Appointment (on appointment basis)";

export const getClinicStatus = () => {
  const now = new Date();
  const day = now.getDay();
  const mins = now.getHours() * 60 + now.getMinutes();
  if (day === 0) return { open: false, label: "Sunday · On Appointment Basis" };
  if (mins >= 11 * 60 && mins < 20 * 60)
    return { open: true, label: "Open Now · Closes 8:00 PM" };
  return { open: false, label: "Opens Today · 11:00 AM" };
};

export const IMAGES = {
  smile:
    "https://images.unsplash.com/photo-1489278353717-f64c6ee8a4d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtYWNybyUyMHRlZXRoJTIwc21pbGUlMjBkZW50aXN0fGVufDB8fHx8MTc5MTgwOTQ3M3ww&ixlib=rb-4.1.0&q=85",
  enamelProfile:
    "https://images.unsplash.com/photo-1677026010083-78ec7f1b84ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxkZW50aXN0JTIwcGF0aWVudCUyMHNtaWxlJTIwY2xvc2UlMjB1cHxlbnwwfHx8fDE3OTE4MDk0Nzl8MA&ixlib=rb-4.1.0&q=85",
  suiteInterior:
    "https://images.unsplash.com/photo-1781513144825-aa1e284c5950?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBkZW50YWwlMjBjbGluaWMlMjBsdXh1cnklMjBpbnRlcmlvcnxlbnwwfHx8fDE3OTE4MDk0NzZ8MA&ixlib=rb-4.1.0&q=85",
  lounge:
    "https://images.unsplash.com/photo-1771270731007-5998fa136d12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBkZW50YWwlMjBjbGluaWMlMjBsdXh1cnklMjBpbnRlcmlvcnxlbnwwfHx8fDE3OTE4MDk0NzZ8MA&ixlib=rb-4.1.0&q=85",
  precision:
    "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxkZW50aXN0JTIwcGF0aWVudCUyMHNtaWxlJTIwY2xvc2UlMjB1cHxlbnwwfHx8fDE3OTE4MDk0Nzl8MA&ixlib=rb-4.1.0&q=85",
};

export const SERVICE_IMAGES = [
  IMAGES.precision,
  IMAGES.enamelProfile,
  IMAGES.smile,
  IMAGES.suiteInterior,
  IMAGES.lounge,
];

export const HERO_SMILE =
  "https://images.unsplash.com/photo-1618245472177-2a74ad3b994a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBzbWlsZXxlbnwwfHx8fDE3OTE4MjY5ODV8MA&ixlib=rb-4.1.0&q=85";

export const SMILE_GALLERY = [
  {
    id: "case-whitening",
    short: "Laser Whitening",
    title: "Laser Teeth Whitening",
    timeline: "Single Sitting · 45 mins",
    desc: "Removal of deep stains and discolouration using non-invasive cold laser activation — visibly brighter in one visit.",
    metric: "8 Shades Brighter",
    image:
      "https://images.unsplash.com/photo-1663182234283-28941e7612da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHx0ZWV0aCUyMHNtaWxlJTIwY2xvc2V1cHxlbnwwfHx8fDE3OTE4MjY5ODV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "case-veneers",
    short: "Smile Designing",
    title: "Digital Smile Designing & Porcelain Veneers",
    timeline: "2 Appointments · 7 Days",
    desc: "Correction of gaps and edge wear with ultra-thin E-Max ceramic laminates, designed around your facial symmetry.",
    metric: "Golden Ratio Symmetry",
    image:
      "https://images.unsplash.com/photo-1489278353717-f64c6ee8a4d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHx0ZWV0aCUyMHNtaWxlJTIwY2xvc2V1cHxlbnwwfHx8fDE3OTE4MjY5ODV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "case-rehab",
    short: "Full Arch Rehab",
    title: "Full Arch Aesthetic Rehabilitation",
    timeline: "Rotary Micro-Endo + Zirconia Crown",
    desc: "Complex endodontic tooth conservation paired with high-translucency CAD-CAM zirconia restoration.",
    metric: "100% Bite Preservation",
    image:
      "https://images.unsplash.com/photo-1677026010083-78ec7f1b84ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHx0ZWV0aCUyMHNtaWxlJTIwY2xvc2V1cHxlbnwwfHx8fDE3OTE4MjY5ODV8MA&ixlib=rb-4.1.0&q=85",
  },
];
